<template>
    <el-container direction="vertical" class="card-deal card-deal-wrapper" v-loading="loading">
        <el-row class="card-deal-header">
            <el-col :span="20">
                <el-row>
                    <el-col :span="6" class="grey">
                        ID <span v-if="dealId">
                            {{ dealId }} ( {{ dealCreatedAt }})
                        </span>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col class="page-title bold fnt-lg dark text-left">
                        {{ title }} ({{ address }})
                    </el-col>
                </el-row>
                <div v-if="this.$store.state.deals.current.lead && this.$store.state.deals.current.lead.duplicated_leads[0]">
                    Дубликаты Лидов:
                </div>
                <div v-if="this.$store.state.deals.current.lead">
                    <div v-for="duplicatedLead in this.$store.state.deals.current.lead.duplicated_leads" :key="duplicatedLead.id" class="text-left link" @click="goLead(duplicatedLead.id)">
                        {{ duplicatedLead.id }}, {{ duplicatedLead.title }},
                        обращение в офис {{ getOfficeNameById(duplicatedLead.office_id) }} {{ duplicatedLead.created_at }},
                        <span :class="{ red: duplicatedLead.status_id === 3 , green: duplicatedLead.status_id === 2 }">
                            {{ getStatusNameById(duplicatedLead.status_id) }}
                            <span v-if="duplicatedLead.status_id === 3 && duplicatedLead.refuse_reason">
                                ({{ duplicatedLead.refuse_reason.reference_refuse_reason.name }})
                            </span>
                            <span v-if="duplicatedLead.status_id === 2">
                                ({{ duplicatedLead.deal.status.name }})
                            </span>
                        </span>
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-row class="card-deal-tabs">
            <div
                v-for="tab in tabs"
                :key="tab.component"
                :class="['tab-name', { active: currentTab === tab.component }]"
                @click="currentTab = tab.component"
            >
                {{ tab.title }}
            </div>
        </el-row>
        <keep-alive>
            <component :is="currentTab" :deal-id="this.id" />
        </keep-alive>
    </el-container>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheck, faCheckSquare, faEye, faPaperclip } from '@fortawesome/free-solid-svg-icons';
import { faSquare } from '@fortawesome/free-regular-svg-icons';
import '@/assets/styles/card.scss';
import '@/assets/styles/card-complex.scss';
import MainInfo from '@/views/crm/deals/card-tabs/MainInfo';
import Income from '@/views/crm/deals/card-tabs/Income';
import Expense from '@/views/crm/deals/card-tabs/Expense';
import { eventBus } from '@/common/eventBus';

library.add(faCheck, faCheckSquare, faSquare, faEye, faPaperclip);

export default {
    name: 'DealCard',
    props: {
        id: {
            type: [String, Number],
            default: 0
        }
    },
    data() {
        return {
            loading: true,
            data: {},
            currentTab: 'main-info',
            tabs: [
                { component: 'main-info', title: 'общая информация' },
                { component: 'income', title: 'приходы' },
                { component: 'expense', title: 'расходы' }
            ]
        };
    },
    components: {
        MainInfo,
        Income,
        Expense
    },
    beforeMount() {
        if (!this.isNew) {
            this.getCard(this.id);
        } else {
            this.loading = false;
        }
    },
    computed: {
        contactName() {
            const contact = this.$store.state.deals.current.contact;
            return contact ? contact.name : '';
        },
        isNew() {
            return +this.id === 0;
        },
        dealId() {
            return this.$store.state.deals.current.id;
        },
        address() {
            return this.$store.state.deals.current.address;
        },
        title() {
            return this.$store.state.deals.current.title;
        },
        dealCreatedAt() {
            return this.$store.state.deals.current.created_at;
        }
    },
    beforeDestroy() {
        this.$store.commit('deals/clearCurrent');
        this.$store.commit('events/clearEvents');
        this.$store.commit('tasks/clearStore');
    },
    methods: {
        async getCard(id) {
            this.loading = true;
            try {
                await this.$store.dispatch('deals/getDeal', id);
                eventBus.$emit('tasks-need-update', { entityType: 'deal', entityId: id });
                eventBus.$emit('events-need-update');
            } catch (error) {
                this.$router.push({ name: 'deals' });
            } finally {
                this.loading = false;
            }
        },
        goLead(id) {
            this.id = id;
            this.$router.push({ name: 'lead-card-view', params: { id: '' + id } });
            this.getLead();
        },
        getOfficeNameById(id) {
            if (!id) {
                return 'не указан';
            }
            return this.$store.getters['references/getOfficeNameById'].filter(item => item.id === id)[0].name;
        },
        getStatusNameById(statusId = null) {
            let status = '';
            if (statusId === 3) {
                status = 'не целевой';
            } else if (statusId === 2) {
                status = 'целевой';
            } else if (statusId === 1) {
                status = 'не обработан';
            }
            return status;
        }
    },
    watch: {
        id(newValue, oldValue) {
            //подгружаем данные по новому id сделки
            if (newValue && oldValue) {
                this.getCard(newValue);
            }
        }
    }
};
</script>
